export default "__VITE_ASSET__deyn5mSx__"